import { ApolloClient } from '@apollo/client';
import { createApolloLinks } from "./apolloLinks";
export const createApolloClient = options => {
  const {
    uri,
    name,
    version,
    ssrMode = false,
    cache
  } = options;
  const client = new ApolloClient({
    cache,
    ssrMode,
    link: createApolloLinks({
      uri,
      name,
      version
    })
  });
  return client;
};